module.exports = __webpack_public_path__ + "static/qmclouds-og-img-7e0523041e9fcf8e358b8c0c24db4246.png";